<vc-dialog
    [(visible)]="visible"
    [title]="'ASSESSMENT.ZIP_UPLOAD.TITLE.UPLOADING_ZIP_FILE' | transloco"
    [primaryLabel]="'ASSESSMENT.ZIP_UPLOAD.TITLE.UNZIP' | transloco"
    [secondaryLabel]="'ASSESSMENT.ZIP_UPLOAD.TITLE.UPLOAD_ONLY' | transloco"
    [closeOnSecondary]="true"
    [clearFormOnClose]="true"
    [actionsOnLeft]="false"
    (primaryTrigger)="uploadOnly(false)"
    (secondaryTrigger)="uploadOnly(true)">
    <div>{{ 'ASSESSMENT.ZIP_UPLOAD.TITLE.YOU_ARE_UPLOADING_ZIP_FILE' | transloco }}</div>
</vc-dialog>
